const rtf = new Intl.RelativeTimeFormat('es-CL', {
  style: 'short',
  numeric: 'always',
});

const switchTimes = (seconds = 0) => {
  let sufix: Intl.RelativeTimeFormatUnit = 'hours';
  let time = seconds / 3600;

  if (Math.abs(seconds) < 60) {
    sufix = 'seconds';
    time = seconds;
  } else if (Math.abs(seconds) < 3600) {
    sufix = 'minutes';
    time = seconds / 60;
  }

  return { sufix, time };
};

export const formatTime = (date: number = 0) => {
  const { sufix, time } = switchTimes(date);
  return rtf.format(Math.ceil(time), sufix);
};

export const formatDate = (dateStart = new Date()) => {
  const dateNow = new Date().getTime();
  const deltaDate = (-1 * dateNow - -1 * dateStart.getTime()) / 1e3;
  const { sufix, time } = switchTimes(deltaDate);

  return rtf.format(Math.ceil(time), sufix);
};

export const formatToISO8601 = (timeStr: string): string => {
  const today = new Date();
  const dateStr = today.toISOString().split('T')[0];
  const [hours, minutes] = timeStr.split(':');
  return `${dateStr}T${hours}:${minutes}:00-04:00`;
};

export const durationToISO8601 = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  let duration = 'PT';
  if (hours > 0) duration += `${hours}H`;
  if (mins > 0) duration += `${mins}M`;
  return duration === 'PT' ? 'PT0M' : duration;
};
